import { PricePlanRowPureType } from 'domain/api/graphql/generated';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

type GetTextProps = {
  row: PricePlanRowPureType;
  withPrimeDiscount?: boolean;
};

export const getText = ({ row, withPrimeDiscount = false }: GetTextProps) => {
  if (row.stepRangeLower === 1 && row.stepRangeUpper === 2) {
    return TEXTS.BILLING_RATES_TABLE_STEP_LOWER_ADDRESS;
  }

  if (row.stepRangeLower === 1 && row.stepRangeUpper == null) {
    return TEXTS.BILLING_RATES_TABLE_STEP_FROM_ADDRESS(row.stepRangeLower);
  }

  if (row.stepRangeLower && row.stepRangeUpper) {
    if (withPrimeDiscount) {
      return TEXTS.BILLING_RATES_TABLE_STEP_RANGE_ADDRESSES(row.stepRangeLower + 1, row.stepRangeUpper - 1);
    }

    return TEXTS.BILLING_RATES_TABLE_STEP_RANGE_ADDRESSES(row.stepRangeLower, row.stepRangeUpper - 1);
  }

  return TEXTS.BILLING_RATES_TABLE_STEP_HIGHER_ADDRESS(row.stepRangeLower);
};

export const getSubscriptionPeriod = (payFrequencyMonth: number) => {
  if (payFrequencyMonth === 12) {
    return TEXTS.RATES_BLOCK_RATES_YEAR_TEXT;
  }

  return TEXTS.RATES_BLOCK_RATES_MONTH_TEXT;
};
